import { useApiClient } from './apiClient';
import { useCallback, useMemo } from 'react';

export const useStudentClassAPIs = () => {
  const { get, post } = useApiClient();

  const fetchStudentClasses = useCallback(async () => {
    try {
      const data = await get('api/student-classes');
      if (Array.isArray(data)) {
        return data;
      }
      // Handle Spring Data REST format if needed
      if (data._embedded && data._embedded.studentClasses) {
        return data._embedded.studentClasses;
      }
      return [];
    } catch (err) {
      console.error("Failed to fetch student classes:", err);
      return [];
    }
  }, [get]);

  const addStudentClass = useCallback(async (name) => {
    try {
      // apiClient.post already does JSON.stringify, so we pass the string directly
      const response = await post('api/student-classes/add', name);
      return response;
    } catch (err) {
      console.error("Failed to add student class:", err);
      return null;
    }
  }, [post]);

  const getOrCreateStudentClass = useCallback(async (name) => {
    if (!name || !name.trim()) {
      return null;
    }
    
    try {
      // Try to add the student class (will return existing if already present)
      const studentClass = await addStudentClass(name.trim());
      return studentClass;
    } catch (err) {
      console.error("Failed to get or create student class:", err);
      return null;
    }
  }, [addStudentClass]);

  return useMemo(() => ({
    fetchStudentClasses,
    addStudentClass,
    getOrCreateStudentClass,
  }), [fetchStudentClasses, addStudentClass, getOrCreateStudentClass]);
};

